package geometry

import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.map
import math.easeInOutQuad
import kotlin.math.PI
import kotlin.math.cos

class Eye(
    center: Vector2,
    radius: Double,
    resolution:Int = 180,
) : Crescent (center, radius, resolution){
    var triggered = false
    var lowerRange = 0.2
    var upperRange = 1.0
    var duration = 30 //in frames
    var count = 0
    init {
        rotation = PI
        stage = lowerRange
    }
    fun trigger(){
        if(!triggered) triggered = true
    }
    fun update(){
        if(triggered){
            val step = (PI *2.0) / duration.toDouble()
            stage = cos(PI +(step*count))
                .let{ it*0.5+0.5 }
                .let { easeInOutQuad(it) }
                .let{
                    map(0.0,1.0,lowerRange,upperRange,it)
                }
            count++
            if(count==duration){
                triggered = false
                count = 0
            }
        }
    }
}
